<template>
  <div class="has-fixed-page-subheader">
    <div class="page-subheader d-flex">
      <div class="page-subheader-content d-flex text-center align-self-center">
        <span class="  text-center align-self-center">
          View Walk Through
        </span>
        <router-link
          :to="`/customerView/${customerId}`"
          class="back-to-dashboard-link   text-center align-self-center"
        >
          Back to Dashboard
        </router-link>
      </div>
    </div>
    <v-skeleton-loader class="mx-auto ml-2 mr-2" type="card" :loading="loading">
      <!-- <v-container fluid class="mb-4"> -->
      <v-card
        elevation="0"
        outlined
        :loading="requestProcessing"
        class="border-0"
      >
        <template slot="progress">
          <v-progress-linear height="10" indeterminate></v-progress-linear>
          <p class="mt-4 text-center">Processing...</p>
        </template>
        <!-- <v-card-title
          v-if="!requestProcessing"
          class="orange-bg font-weight-bold white--text"
        >
          Walk-Through
          <v-divider
            vertical
            thickness="2"
            class="border-opacity-100 mx-3"
            color="white"
          ></v-divider>
          <router-link
            :to="`/customers/${customerId}`"
            class="back-to-dashboard-link"
          >
            Back to Dashboard
          </router-link>
        </v-card-title> -->
        <v-card-text v-if="!requestProcessing">
          <!-- Start Walk-Throughs section -->
          <v-container>
            <v-row class="mb-4">
              <v-col>
                <span class="text-orange text-h3 font-weight-bold">
                  {{ communityInfo.name }}
                </span>
              </v-col>
            </v-row>
            <v-row class="mb-4">
              <v-col>
                <span class="text-h4 font-weight-bold">
                  Grade: {{ walkthroughGrade }}
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6">
                <v-label class="font-weight-bolder">
                  Walk-Through Title:
                </v-label>
                <v-select
                  v-model="walkThroughTitle"
                  :items="walkThroughTitleItems"
                  item-text="name"
                  item-value="value"
                  label="Walk-Through Title..."
                  required
                  solo
                  readonly
                >
                </v-select>
              </v-col>
              <v-col cols="6" md="6">
                <v-label class="font-weight-bolder">
                  Present for Yardnique:
                </v-label>
                <v-textarea
                  v-model="presentToYn"
                  label="Present for Yardnique..."
                  rows="1"
                  auto-grow
                  solo
                  hide-details
                  readonly
                ></v-textarea>
                <!-- <v-select
                  :loading="loadingCommunityUsers"
                  v-model="presentToYn"
                  :items="presentToYnItems"
                  item-text="fullName"
                  item-value="id"
                  label="Present for Yardnique..."
                  required
                  solo-inverted
                  hide-details
                ></v-select> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6" md="6">
                <v-label class="font-weight-bolder">
                  Prepared By:
                </v-label>
                <v-text-field
                  v-model="preparedBy"
                  label="Prepared By..."
                  required
                  readonly
                  solo
                >
                </v-text-field>
                <!-- <v-select
                  :loading="loadingCommunityUsers"
                  v-model="preparedBy"
                  :items="preparedByItems"
                  item-text="fullName"
                  item-value="id"
                  label="Prepared By..."
                  required
                  solo-inverted
                ></v-select> -->
              </v-col>
              <v-col cols="6" md="6">
                <v-label class="font-weight-bolder">
                  Present for Customer:
                </v-label>
                <v-textarea
                  v-model="presentToCustomer"
                  label="Present for Customer..."
                  rows="1"
                  auto-grow
                  solo
                  hide-details
                  readonly
                ></v-textarea>
                <!-- <v-select
                  :loading="loadingCommunityUsers"
                  v-model="presentToCustomer"
                  :items="presentToCustomerItems"
                  item-text="fullName"
                  item-value="id"
                  label="Present for Customer..."
                  required
                  solo-inverted
                ></v-select> -->
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" cols="6">
                <v-label class="font-weight-bolder">
                  Walk-Through Date:
                </v-label>
                <span class="v-label">
                  {{ formattedWalkThroughDate }}
                </span>
              </v-col>
              <v-col md="6" cols="6">
                <!-- <v-label class="font-weight-bolder">
                  Next Walk-Through Date:
                </v-label>
                <v-menu
                  ref="netWalkThroughDateMenu"
                  v-model="nextWalkThroughDateMenu"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  max-width="290px"
                  min-width="auto"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      v-model="formattedNextWalkThroughDate"
                      label="Next Walk-Through"
                      prepend-icon="mdi-calendar"
                      solo
                      v-bind="attrs"
                      @blur="
                        nextWalkThroughDate = parseDate(
                          formattedNextWalkThroughDate
                        )
                      "
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="nextWalkThroughDate"
                    no-title
                    @input="nextWalkThroughDateMenu = false"
                  ></v-date-picker>
                </v-menu> -->
              </v-col>
            </v-row>
            <div v-for="(areaItem, i) in areaAssessmentItems" :key="'o' + i">
              <v-row>
                <v-col cols="12" class="collapsable-section">
                  <span
                    class="text-h4 font-weight-bolder py-3"
                    @click="areaItem.expanded = !areaItem.expanded"
                  >
                    {{ areaItem.expanded ? "-" : "+" }} {{ areaItem.title }}
                  </span>
                </v-col>
              </v-row>
              <v-row v-if="areaItem.expanded">
                <v-col cols="12">
                  <div>
                    <v-card
                      class="tasksArea border-0 mt-0"
                      elevation="0"
                      outlined
                    >
                      <v-card-text>
                        <table width="100%" class="mt-2">
                          <tr
                            class="task-item"
                            v-for="(serviceItem, i) in areaItem.services"
                            :key="'sa' + i"
                          >
                            <td width="20%">
                              <p class="text-h5 font-weight-bolder">
                                {{ serviceItem.title }}
                              </p>
                            </td>
                            <td width="10%">
                              <v-rating
                                v-model="serviceItem.value"
                                hover
                                :length="5"
                              >
                                <template v-slot:item="props">
                                  <img
                                    height="25"
                                    width="20"
                                    :src="
                                      props.isFilled
                                        ? '/media/assets/active-leaf.png'
                                        : '/media/assets/inactive-leaf.png'
                                    "
                                  />
                                </template>
                              </v-rating>
                            </td>
                            <td width="10%">
                              <v-checkbox
                                v-model="serviceItem.isNa"
                                label="N/A"
                                readonly
                              ></v-checkbox>
                            </td>
                            <td width="auto">
                              <p>
                                <v-textarea
                                  v-model="serviceItem.notes"
                                  label="Notes"
                                  rows="1"
                                  auto-grow
                                  solo
                                  hide-details
                                  readonly
                                ></v-textarea>
                              </p>
                            </td>
                          </tr>
                        </table>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col cols="12" class="collapsable-section">
                <span
                  class="text-h4 font-weight-bolder py-3"
                  @click="
                    isSiteQualityReviewItemsExpanded = !isSiteQualityReviewItemsExpanded
                  "
                >
                  {{ isSiteQualityReviewItemsExpanded ? "-" : "+" }}
                  Site Quality Review Items
                </span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" v-if="isSiteQualityReviewItemsExpanded">
                <div>
                  <v-card
                    class="tasksArea mt-0 border-0"
                    elevation="0"
                    outlined
                  >
                    <v-card-text>
                      <table width="100%" class="mt-2">
                        <tr
                          class="task-item"
                          v-for="(item, i) in siteQualityReviewItems"
                          :key="'sqr' + i"
                        >
                          <td width="30%">
                            <MediaUploader
                              v-if="item.url"
                              class="pb-5"
                              :key="item.id"
                              :id="`multiImagePost_${item.id}`"
                              :index="item.id"
                              :accept="accept"
                              :multiple="true"
                              :extensions="extensions"
                              :sizeImage="10485760"
                              :sizeVideo="104857600"
                              :fileId.sync="item.fileId"
                              :file-url.sync="item.url"
                              :isUploading.sync="isFileUploading"
                              @onMultipleUploaded="onMultipleAddFile"
                              @onChange="onChange"
                              @onDeleteFile="onDeleteFile"
                            />
                          </td>
                          <td width="60%">
                            <p
                              class="orange-color font-weight-bolder font-size-h1"
                            >
                              {{ item.title }}
                            </p>
                            <p class="font-size-h3">
                              {{ item.description }}
                            </p>
                            <span
                              class="black-color font-weight-bolder font-size-h2"
                              >Actions:</span
                            >
                            <p class="font-size-h3">
                              {{ item.actions }}
                            </p>
                            <!-- <p>
                              <v-btn>Cancel</v-btn>
                              <v-btn title="Save">Save Item</v-btn>
                            </p> -->
                          </td>
                        </tr>
                        <!-- <tr class="new-task-item">
                          <td width="30%" class="py-5 px-5">
                            <MediaUploader
                              class="pb-5"
                              :key="newQualityReviewItem.id"
                              :id="`imagePost_${newQualityReviewItem.id}`"
                              :index="newQualityReviewItem.id"
                              :accept="accept"
                              :multiple="false"
                              :extensions="extensions"
                              :sizeImage="10485760"
                              :sizeVideo="104857600"
                              :fileId.sync="newQualityReviewItem.fileId"
                              :file-url.sync="newQualityReviewItem.url"
                              :isUploading.sync="isFileUploading"
                              @onMultipleUploaded="onMultipleAddFile"
                              @onChange="onChange"
                              @onDeleteFile="onDeleteFile"
                            />
                          </td>
                          <td width="60%" class="py-5 px-5">
                            <p>
                              <v-textarea
                                label="Title"
                                v-model="newQualityReviewItem.title"
                                rows="1"
                                solo
                              ></v-textarea>
                            </p>
                            <p>
                              <v-textarea
                                label="Description"
                                v-model="newQualityReviewItem.description"
                                solo
                              ></v-textarea>
                            </p>
                            <p>
                              <v-textarea
                                label="Actions"
                                v-model="newQualityReviewItem.actions"
                                solo
                              >
                              </v-textarea>
                            </p>
                            <p class="text-right">
                              <a
                                class="mx-2 text-green"
                                @click="cancelNewQualityReviewItem"
                              >
                                Cancel
                              </a>
                              <v-btn
                                class="mx-2 background-color-green text-white"
                                title="Save"
                                @click="saveNewQualityReviewItem"
                              >
                                Save Item
                              </v-btn>
                            </p>
                          </td>
                        </tr> -->
                      </table>
                    </v-card-text>
                  </v-card>
                </div>
              </v-col>
            </v-row>
          </v-container>
          <!-- End Walk-Throughs section -->
        </v-card-text>
        <v-card-actions v-if="!requestProcessing">
          <v-row>
            <v-col cols="12" class="text-right">
              <router-link
                class="text-green mx-1"
                :to="`/customerView/${customerId}`"
              >
                Cancel
              </router-link>
              <v-btn
                class="text-white background-color-green mx-1"
                @click="downloadPdf"
              >
                Download pdf
              </v-btn>
              <!-- <v-btn
                class="mx-1 background-color-green text-white"
                @click="saveWalkThrough(false)"
              >
                Save Draft
              </v-btn>
              <v-btn
                class="mx-1 background-color-green text-white"
                @click="saveWalkThrough(true)"
              >
                Publish
              </v-btn> -->
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>

      <!-- </v-container> -->
    </v-skeleton-loader>
  </div>
</template>

<style lang="scss">
.collapsable-section {
  border-top: 2px solid #df6526 !important;
  border-bottom: 2px solid #df6526 !important;
}
tr.task-item {
  border-bottom: solid 1px black;
}

tr.task-item td {
  padding-top: 10px;
}

tr.new-task-item {
  background-color: #eeeeee;
}
</style>

<script>
// import { SET_BREADCRUMB } from "@/core/store/breadcrumbs.module";
import {
  GET_QUERY,
  API_CUSTOMERS,
  POST_DATA,
  // PUT_DATA,
  API_WALKTHROUGHS
  // API_QUARTERLY_PLAN_TEMPLATES
} from "@/core/store/crud.module";
import crud from "@/core/helpers/crud";
// import dateFormatter from "@/core/helpers/dateFormatter";
import stringFormatter from "@/core/helpers/stringFormatter";
import { validationMixin } from "vuelidate";
// import dataModels from "@/core/helpers/datamodels.js";
// import { required } from "vuelidate/lib/validators";
import moment from "moment";
import MediaUploader from "@/view/components/imageUploader/mediaUploader.vue";
import Mgr from "@/core/services/security.service";

export default {
  mixins: [validationMixin],
  components: {
    MediaUploader
  },
  data: () => ({
    mgr: new Mgr(),
    userInfo: null,
    communityInfo: {},
    walkThroughTitle: "",
    walkThroughTitleItems: [
      { name: "Pre-Start Walk-Through", value: "pre" },
      { name: "30-Day Walk-Through", value: "30" },
      { name: "60-Day Walk-Through", value: "60" },
      { name: "90-Day Walk-Through", value: "90" },
      { name: "Quarterly Walk-Through", value: "quarterly" },
      { name: "Supervisor Walk-Through", value: "supervisor" }
    ],
    presentToCustomer: "",
    presentToCustomerItems: [],
    presentToYn: "",
    presentToYnItems: [],
    preparedById: 0,
    preparedBy: "",
    preparedByItems: [],
    areaAssessmentItems: [
      {
        title: "Entryways",
        expanded: true,
        services: [
          { title: "Turf Quality", value: 0, notes: "" },
          { title: "Turf Weed Control", value: 0, notes: "" },
          { title: "Edging", value: 0, notes: "" },
          { title: "Pruning", value: 0, notes: "" },
          { title: "Plant Health", value: 0, notes: "" },
          { title: "Bed Weed Control", value: 0, notes: "" },
          { title: "Irrigation Quality", value: 0, notes: "" },
          { title: "Overall Appearance", value: 0, notes: "" }
        ]
      },
      {
        title: "Common Areas",
        expanded: true,
        services: [
          { title: "Turf Quality", value: 0, notes: "" },
          { title: "Turf Weed Control", value: 0, notes: "" },
          { title: "Edging", value: 0, notes: "" },
          { title: "Pruning", value: 0, notes: "" },
          { title: "Plant Health", value: 0, notes: "" },
          { title: "Bed Weed Control", value: 0, notes: "" },
          { title: "Irrigation Quality", value: 0, notes: "" },
          { title: "Overall Appearance", value: 0, notes: "" }
        ]
      },
      {
        title: "Amenities",
        expanded: true,
        services: [
          { title: "Turf Quality", value: 0, notes: "" },
          { title: "Turf Weed Control", value: 0, notes: "" },
          { title: "Edging", value: 0, notes: "" },
          { title: "Pruning", value: 0, notes: "" },
          { title: "Plant Health", value: 0, notes: "" },
          { title: "Bed Weed Control", value: 0, notes: "" },
          { title: "Irrigation Quality", value: 0, notes: "" },
          { title: "Overall Appearance", value: 0, notes: "" }
        ]
      },
      {
        title: "Perimeters",
        expanded: true,
        services: [
          { title: "Turf Quality", value: 0, notes: "" },
          { title: "Turf Weed Control", value: 0, notes: "" },
          { title: "Edging", value: 0, notes: "" },
          { title: "Pruning", value: 0, notes: "" },
          { title: "Plant Health", value: 0, notes: "" },
          { title: "Bed Weed Control", value: 0, notes: "" },
          { title: "Irrigation Quality", value: 0, notes: "" },
          { title: "Overall Appearance", value: 0, notes: "" }
        ]
      }
    ],
    isSiteQualityReviewItemsExpanded: true,
    siteQualityReviewItems: [
      // { title: "", description: "", actions: "", image: {} }
    ],
    newQualityReviewItem: {
      title: "",
      description: "",
      actions: "",
      id: 1,
      url: null,
      fileId: 0
    },
    // photosObj: [{ id: 1, url: null }],
    isFileUploading: false,
    videoExtensions: "mp4,mov,avi,mkv,mpg,vob,wmv,m4v,asf,srt",
    relatedCommunity: null,
    relatedCommunityItems: [],
    walkThroughDate: null,
    formattedWalkThroughDate: null,
    nextWalkThroughDate: null,
    formattedNextWalkThroughDate: null,
    nextWalkThroughDateMenu: false,
    options: {
      page: 1,
      itemsPerPage: 5
    },
    hasMore: false,
    isLoading: false,
    loading: false,
    snackbarContent: "",
    snackbarColor: "#F06835",
    breadcrumbs: [],
    requestProcessing: false,
    loadingCommunityUsers: false,
    walkthroughGrade: "F",
    baseUrl: `${process.env.VUE_APP_DASHBOARD_URL}`
  }),
  props: {
    customerId: {
      type: [Number, String],
      default: 0
    },
    walkThroughId: {
      type: [Number, String],
      default: 0
    }
  },
  validations() {
    return true;
    // return {
    //   billingInfo: {
    //     subscription: {
    //       nextBillingDates: {
    //         required,
    //         minDate: value =>
    //           dateFormatter.convertToMilliseconds(value) >
    //           dateFormatter.convertToMilliseconds(new Date())
    //       }
    //     }
    //   }
    // };
  },
  watch: {
    walkThroughDate: function() {
      this.formattedWalkThroughDate = this.formatDate(this.walkThroughDate);
    },
    nextWalkThroughDate: function() {
      this.formattedNextWalkThroughDate = this.formatDate(
        this.nextWalkThroughDate
      );
    }
  },
  async mounted() {
    await this.getComunityInfo();
    await this.getWalkThrough();
    // this.loading = true;
    // await this.createBreadcrumb();
    // await this.setInternalBreadcrumbs();
    // this.loading = false;
    // await this.getEmployees();
  },
  async created() {
    // await this.getComunityInfo();
    // if (this.$route.query.sourcePlanId || this.$route.query.sourceTemplateId)
    //   await this.getNinetyDayPlan();

    this.userInfo = await this.mgr.getUser();

    // this.walkThroughDate = new Date().toISOString().substr(0, 10);
    // this.preparedBy = this.userInfo.profile.fullName;
    // this.preparedById = this.userInfo.Id;
    // // console.log("userInfo", this.userInfo);
    // this.formattedNextWalkThroughDate = this.formatDate(this.walkThroughDate);
  },
  methods: {
    urlToBase64(reviewItems) {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.crossOrigin = "Anonymous";
        img.src = reviewItems.url;
        img.onload = () => {
          const canvas = document.createElement("canvas"),
            ctx = canvas.getContext("2d");
          canvas.height = img.height;
          canvas.width = img.width;
          ctx.drawImage(img, 0, 0);
          resolve({
            title: reviewItems.title,
            description: reviewItems.description,
            actions: reviewItems.actions,
            url: canvas.toDataURL("image/jpeg")
          });
        };
        img.onerror = error => reject(error);
      });
    },
    async downloadPdf() {
      let pdfMake = require("pdfmake/build/pdfmake.js");
      if (pdfMake.vfs == undefined) {
        var pdfFonts = require("pdfmake/build/vfs_fonts.js");
        pdfMake.vfs = pdfFonts.pdfMake.vfs;
      }

      let self = this;

      pdfMake.fonts = {
        Fontello: {
          normal: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bold: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          italics: self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf",
          bolditalics:
            self.baseUrl + "/media/fontello-bcdeccb8/font/fontello.ttf"
        },

        //download default Roboto font from cdnjs.com
        Roboto: {
          normal:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Regular.ttf",
          bold:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Medium.ttf",
          italics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-Italic.ttf",
          bolditalics:
            "https://cdnjs.cloudflare.com/ajax/libs/pdfmake/0.1.66/fonts/Roboto/Roboto-MediumItalic.ttf"
        }
      };

      // let serviceDateModified = new Date(self.orangeReport.serviceDate)
      //   .toISOString()
      //   .substr(0, 10);

      // let servicesRendered = this.orangeReport.servicesRendered.$values.map(
      //   item => item.name
      // );

      // console.log(servicesRendered);

      let promisses = this.siteQualityReviewItems.map(photo => {
        return this.urlToBase64(photo);
        // return {
        //   title: photo.title,
        //   description: photo.description,
        //   actions: photo.actions,
        //   url: this.urlToBase64(photo.url)
        // };
      });

      //  => icon-dot-circled
      // const iconDotCircled = "";
      //  => icon-empty-circle
      // const iconEmptyCircle = "";

      Promise.allSettled(promisses).then(function(res) {
        let borderObj = {
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: "",
                  border: [false, true, false, false],
                  borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"]
                }
              ]
            ]
          },
          style: "mt5"
        };

        let hasReviewItems = res.length > 0;
        let reviewItems = res.map(res => {
          return {
            table: {
              widths: [200, "*"],
              body: [
                // [
                //   {
                //     text: "",
                //     border: [false, true, false, false],
                //     borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"],
                //     colSpan: 2
                //   },
                //   {}
                // ],
                [
                  {
                    border: [false, true, false, false],
                    borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"],
                    image: res.value.url,
                    style: "photos",
                    width: 200,
                  },
                  {
                    border: [false, true, false, false],
                    borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"],
                    style: "photos",
                    stack: [
                      {
                        text: res.value.title,
                        fontSize: 12,
                        alignment: "left",
                        color: "#E06521"
                        // margin: [5, 5, 5, 5]
                      },
                      {
                        text: res.value.description,
                        alignment: "left"
                        // margin: [5, 5, 5, 5]
                      },
                      {
                        text: "Actions",
                        fontSize: 11,
                        alignment: "left",
                        color: "#E06521",
                        style: "mt5"
                        // margin: [5, 5, 5, 5]
                      },
                      {
                        text: res.value.actions,
                        alignment: "left"
                        // margin: [5, 5, 5, 5]
                      }
                    ]
                  }
                ]
              ]
            },
            //layout: "noBorders"
            layout: {
              defaultBorder: false
            }
          };
        });

        // console.log(reviewItems);

        // let reportImages = res.map(res => {
        //   return {
        //     image: res.value, //this.dataUrl,//"sidebar", //photo.fileUrl,
        //     style: "photos",
        //     width: 100
        //     // height: 60
        //   };
        // });

        let serviceItems = [];
        self.areaAssessmentItems.forEach(function(el) {
          serviceItems.push(borderObj);
          serviceItems.push({
            text: el.title,
            fontSize: 13,
            color: "#df6526",
            style: "my5"
          });

          let serviceSubItems = [];

          el.services.forEach(function(intEl) {
            let serviceSubItemColumns = [];
            if (!intEl.isNa) {
              serviceSubItemColumns.push({ text: intEl.title, fontSize: 12 });
              serviceSubItemColumns.push({
                image: "sentiment-" + new Number(intEl.value).toFixed(1),
                width: 100
              });
              serviceSubItems.push(serviceSubItemColumns);
            }
          });

          if (serviceSubItems.length > 0) {
            serviceItems.push({
              table: {
                widths: [150, "*"],
                body: serviceSubItems
              },
              layout: "noBorders"
            });
          }
        });

        // let imagesTableData = [];
        // let imagesColumns = [];
        // for (let i = 0; i < reportImages.length; i++) {
        //   imagesColumns.push(reportImages[i]);

        //   if (imagesColumns.length == 4) {
        //     imagesTableData.push(imagesColumns.slice());
        //     imagesColumns = [];
        //   }
        // }

        // if (imagesColumns.length < 4) {
        //   let missingColumns = 4 - imagesColumns.length;
        //   for (let i = 0; i < missingColumns; i++) {
        //     imagesColumns.push({ text: " " });
        //   }
        //   imagesTableData.push(imagesColumns.slice());
        // }

        // let servicesTableData = [];
        // let servicesColumns = [];
        // for (let i = 0; i < servicesRendered.length; i++) {
        //   servicesColumns.push({
        //     text: [
        //       {
        //         text: iconDotCircled,
        //         style: "icon"
        //       },
        //       " " + servicesRendered[i]
        //     ]
        //   });

        //   if (servicesColumns.length == 4) {
        //     servicesTableData.push(servicesColumns.slice());
        //     servicesColumns = [];
        //   }
        // }

        // if (servicesColumns.length < 4) {
        //   let missingColumns = 4 - servicesColumns.length;
        //   for (let i = 0; i < missingColumns; i++) {
        //     servicesColumns.push({ text: " " });
        //   }
        //   servicesTableData.push(servicesColumns.slice());
        // }

        let docDefinition = {
          images: {
            ynLogo: self.baseUrl + "/media/logos/logo-light.png",
            sidebar: self.baseUrl + "/media/assets/aside-bg.jpg",
            "sentiment-0.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_0.0.png",
            "sentiment-0.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_0.5.png",
            "sentiment-1.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_1.0.png",
            "sentiment-1.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_1.5.png",
            "sentiment-2.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_2.0.png",
            "sentiment-2.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_2.5.png",
            "sentiment-3.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_3.0.png",
            "sentiment-3.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_3.5.png",
            "sentiment-4.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_4.0.png",
            "sentiment-4.5":
              self.baseUrl + "/media/assets/orange-report/Leaf_4.5.png",
            "sentiment-5.0":
              self.baseUrl + "/media/assets/orange-report/Leaf_5.0.png"
          },
          pageSize: "LETTER",
          pageMargins: [40, 40, 40, 40],
          content: [
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: self.communityInfo.name.toUpperCase(),
                  fontSize: 15,
                  bold: true,
                  color: "#df6526"
                }
              ]
            },

            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Grade: " + self.walkthroughGrade,
                  bold: false
                }
              ]
            },
            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Walk-Through Title: " + self.walkThrough.title,
                  bold: false
                }
              ]
            },
            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Prepared by: " + self.preparedBy,
                  bold: false
                }
              ]
            },
            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Present for Yardnique: " + self.presentToYn,
                  bold: false
                }
              ]
            },
            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Present for Customer: " + self.presentToCustomer,
                  bold: false
                }
              ]
            },
            "\n",
            {
              columns: [
                {
                  // star-sized columns fill the remaining space
                  // if there's more than one star-column, available width is divided equally
                  width: "*",
                  text: "Walk-Through Date: " + self.formattedWalkThroughDate,
                  bold: false
                }
              ]
            },
            "\n",
            // service items start section
            // {
            //   table: {
            //     widths: ["*"],
            //     body: [
            //       [
            //         {
            //           text: "",
            //           border: [false, true, false, false],
            //           borderColor: ["#E06521", "#E06521", "#E06521", "#E06521"]
            //         }
            //       ]
            //     ]
            //   },
            //   style: "mt5"
            // },
            serviceItems,
            {
              text: hasReviewItems ? "Site Quality Review Items" : " ",
              fontSize: 13,
              color: "#df6526",
              style: "my5"
            },
            reviewItems
          ],
          defaultStyle: {
            fontSize: 8,
            bold: false
          },
          styles: {
            heading: {
              color: "#000000", // "#E06521",
              bold: true,
              margin: [0, 5, 0, 5]
            },
            icon: { font: "Fontello" },
            photos: {
              margin: [0, 10, 0, 10]
            },
            mt5: { margin: [0, 5, 0, 0] },
            mt10: { margin: [0, 10, 0, 0] },
            mb5: { margin: [0, 0, 0, 5] },
            mb10: { margin: [0, 0, 0, 10] },
            my5: { margin: [0, 5, 0, 5] },
            my10: { margin: [0, 10, 0, 10] }
          }
        };
        pdfMake.createPdf(docDefinition).open();
      });
    },
    async getComunityInfo() {
      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_CUSTOMERS,
          id: this.customerId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.communityInfo = crud.getPopulatedComunityInfo(response.data);
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }
        });
    },
    setRatingValue(props, item, index) {
      // console.log("props", props);
      item.value = index + 1;
      // props.value = index + 1;
    },
    cancelNewQualityReviewItem(event) {
      event.preventDefault();

      this.newQualityReviewItem = {
        title: "",
        description: "",
        actions: "",
        id: 1,
        url: null
      };
    },
    saveNewQualityReviewItem() {
      this.siteQualityReviewItems.push({
        title: this.newQualityReviewItem.title,
        description: this.newQualityReviewItem.description,
        actions: this.newQualityReviewItem.actions,
        id: this.newQualityReviewItem.id,
        url: this.newQualityReviewItem.url,
        fileId: this.newQualityReviewItem.fileId
        // photo: {
        //   id: this.newQualityReviewItem.fileId,
        //   fileUrl: this.newQualityReviewItem.url
        // }
      });
      this.newQualityReviewItem = {
        title: "",
        description: "",
        actions: "",
        id: 1,
        url: null
      };
    },
    // showRelatedCommunity(communityId) {
    //   this.$router.push({
    //     name: "CustomerDetails",
    //     params: { customerId: communityId }
    //   });
    // },
    // async getEmployees() {
    //   this.loadingCommunityUsers = true;
    //   await this.$store
    //     .dispatch(GET_QUERY, {
    //       listName: `${API_CUSTOMERS}/${this.customerId}/users`
    //     })
    //     .then(response => {
    //       if (response.status >= 200 || response.status <= 204) {
    //         this.preparedByItems = response.data.$values;
    //         this.presentToCustomerItems = response.data.$values;
    //         this.presentToYnItems = response.data.$values;
    //       } else {
    //         this.$snackbar.showMessage({
    //           content:
    //             response.data ||
    //             "Cannot receive a list of users. Something went wrong.",
    //           color: "red"
    //         });
    //       }
    //       this.loadingCommunityUsers = false;
    //     });
    // },

    populatePhotosObj(photos) {
      this.photosObj = photos.map(obj => {
        return { id: obj.id, url: obj.fileUrl, fileId: obj.id };
      });
      let max = Math.max(...this.photosObj.map(i => i.id));
      this.photosObj.push({ id: (max += 1), url: null });
    },
    async getWalkThrough() {
      this.requestProcessing = true;
      await this.$store
        .dispatch(GET_QUERY, {
          listName: API_WALKTHROUGHS,
          id: this.walkThroughId
        })
        .then(response => {
          if (response.status >= 200 || response.status <= 204) {
            this.walkThrough = response.data;

            this.walkThroughTitle = this.walkThroughTitleItems.find(
              el => el.name == this.walkThrough.title
            ).value;

            this.walkThroughDate = new Date(this.walkThrough.walkthroughDate)
              .toISOString()
              .substr(0, 10);
            this.formattedWalkThroughDate = this.formatDate(
              this.walkThroughDate
            );

            this.presentToCustomer = this.walkThrough.presentForCustomer;
            this.presentToYn = this.walkThrough.presentForYn;
            this.preparedById = this.walkThrough.createdById;
            this.preparedBy = this.walkThrough.createdBy;

            // for (let i = 0; i < this.walkThrough.areas.$values.length; i++) {
            //   var item = this.areaAssessmentItems.find(
            //     el => el.title == this.walkThrough.areas.$values[i].title
            //   );
            //   for (
            //     let j = 0;
            //     this.walkThrough.areas.$values[i].servceAssessments.$values
            //       .length;
            //     j++
            //   ) {
            //     var serviceItem = item.services.find(
            //       el =>
            //         el.title ==
            //         this.walkThrough.areas.$values[i].servceAssessments.$values[
            //           j
            //         ].title
            //     );
            //     serviceItem.value = this.walkThrough.areas.$values[
            //       i
            //     ].servceAssessments.$values[j].value;
            //     serviceItem.notes = this.walkThrough.areas.$values[
            //       i
            //     ].servceAssessments.$values[j].notes;
            //     serviceItem.isNA = this.walkThrough.areas.$values[
            //       i
            //     ].servceAssessments.$values[j].isNA;
            //   }
            // }

            this.areaAssessmentItems = this.walkThrough.areas.$values.map(i => {
              return {
                title: i.title,
                expanded: true,
                services: i.servceAssessments.$values
                  .filter(item => !item.isNA)
                  .map(j => {
                    return {
                      title: j.title,
                      value: j.value,
                      notes: j.notes,
                      isNa: j.isNA
                    };
                  })
              };
            });

            this.walkthroughGrade = "F";
            let serviceValuesSum = 0.0;
            let meaningServicesCount = 0;

            this.areaAssessmentItems.forEach(function(el) {
              el.services.forEach(function(intEl) {
                if (!intEl.isNa) {
                  serviceValuesSum += intEl.value;
                  meaningServicesCount++;
                }
              });
            });
            if (meaningServicesCount > 0) {
              let avg = serviceValuesSum / meaningServicesCount;
              if (avg >= 4.0) this.walkthroughGrade = "A";
              else if (avg >= 2.5) this.walkthroughGrade = "C";
              else if (avg > 0) this.walkthroughGrade = "F";
            }

            this.siteQualityReviewItems = this.walkThrough.reviews.$values.map(
              i => {
                return {
                  title: i.title,
                  description: i.description,
                  actions: i.actions,
                  fileId: i.photo?.id,
                  url: i.photo?.fileUrl,
                  id: i.photo?.id
                  // photo: { id: i.fileId, fileUrl: i.url }
                };
              }
            );

            // this.renderedServices = this.orangeReport.servicesRendered.$values.map(
            //   s => s.name
            // );
          } else {
            this.$snackbar.showMessage({
              content: response.data || "Something went wrong!",
              color: "red"
            });
          }

          this.requestProcessing = false;
        });
    },
    saveWalkThrough(isApproved) {
      if (!this.walkThroughTitle) {
        this.$snackbar.showMessage({
          content: "Walk-Through Title should be populated.",
          color: this.snackbarColor
        });
        return;
      }

      if (!this.walkThroughDate) {
        this.$snackbar.showMessage({
          content: "Walk-Through Date should be populated.",
          color: this.snackbarColor
        });
        return;
      }
      let walkthrough = {};
      walkthrough.propertyId = this.customerId;
      walkthrough.title = this.walkThroughTitleItems.find(
        el => el.value == this.walkThroughTitle
      ).name;
      walkthrough.walkThroughDate = moment.utc(this.walkThroughDate);
      walkthrough.nextWalkThroughDate = moment.utc(this.walkThroughDate);
      // walkthrough.nextWalkThroughDate = moment.utc(this.nextWalkThroughDate);
      walkthrough.presentForCustomer = this.presentToCustomer;
      walkthrough.presentForYn = this.presentToYn;
      walkthrough.createdById = this.preparedById;

      if (isApproved) walkthrough.isApproved = true;

      walkthrough.areas = this.areaAssessmentItems.map(i => {
        return {
          title: i.title,
          servceAssessments: i.services.map(j => {
            return {
              title: j.title,
              value: j.value,
              notes: j.notes,
              isNA: j.isNa
            };
          })
        };
      });
      walkthrough.reviews = this.siteQualityReviewItems.map(i => {
        return {
          title: i.title,
          description: i.description,
          actions: i.actions,
          photo: { id: i.fileId, fileUrl: i.url }
        };
      });

      var self = this;

      // this.plan.photos = this.photosObj
      //   .filter(
      //     i =>
      //       i.url &&
      //       i.url.length > 0 &&
      //       !self.videoExtensions.includes(self.getExtensionFromUrl(i.url))
      //   )
      //   .map(i => {
      //     return { id: i.fileId, fileUrl: i.url };
      //   });
      // this.plan.photos = this.plan.photos.filter(
      //   (item, index) => this.plan.photos.indexOf(item) === index
      // ); //remove duplicates

      let url = `${API_WALKTHROUGHS}`;
      let action = POST_DATA;
      // if (this.planId) {
      //   url = `${API_CUSTOMERS}/${this.customerId}/plans/${this.planId}`;
      //   action = PUT_DATA;
      // }

      self.requestProcessing = true;

      self.$store
        .dispatch(action, {
          listName: url,
          data: walkthrough
        })
        .then(response => {
          if (response) {
            self.snackbarContent = "Walk-Through has been saved successfully";
            self.$router.push({
              name: "CustomerDetails",
              params: { customerId: self.customerId }
            });
          } else {
            self.snackbarContent = "Something went wrong!"; //response.data;
            self.snackbarColor = "red";
          }
          self.$snackbar.showMessage({
            content: self.snackbarContent,
            color: self.snackbarColor
          });

          self.confirmDialog = self;
          self.requestProcessing = false;
        })
        .catch(err => {
          self.$snackbar.showMessage({
            content: err,
            color: self.snackbarColor
          });
          self.requestProcessing = false;
        });
    },
    onMultipleAddFile(files) {
      for (var i = 1; i < files.length; i++) {
        let max = Math.max(...this.siteQualityReviewItems.map(i => i.id));
        this.siteQualityReviewItems.push({
          id: (max += 1),
          url: files[i].fileUrl,
          fileId: files[i].id
        });
      }
      // let max = Math.max(...this.photosObj.map(i => i.id));
      // this.photosObj.push({ id: (max += 1), url: null });
      this.$nextTick(() => files.forEach(f => this.onChange(f)));
    },
    onChange(file) {
      // console.log("file", file);
      // console.log("newQualityReviewItem", this.newQualityReviewItem);
      if (file.fileUrl) {
        var found = this.siteQualityReviewItems.find(
          f => f.url == file.fileUrl
        );

        if (!found) return;

        // if (!found) {
        //   found = {
        //     id: this.newQualityReviewItem.id,
        //     url: file.fileUrl,
        //     title: this.newQualityReviewItem.title,
        //     description: this.newQualityReviewItem.description,
        //     actions: this.newQualityReviewItem.actions,
        //     fileId: file.id
        //   };
        //   this.siteQualityReviewItems.push(found);

        found.fileId = file.id;

        var extension = this.getExtensionFromUrl(file.fileUrl);
        var isVideo = this.videoExtensions.includes(extension);
        if (isVideo) {
          var videoInStore = 0;
          this.photosObj.forEach(obj => {
            var ext = this.getExtensionFromUrl(obj.url);
            var isVideo = this.videoExtensions.includes(ext);
            if (isVideo) videoInStore += 1;
          });
          if (videoInStore > 1) {
            let found = this.siteQualityReviewItems.find(
              f => f.url == file.fileUrl
            );
            let index = this.siteQualityReviewItems.indexOf(found);
            this.photosObj.splice(index, 1);
            this.saveResult.text = "You can add only one video";
            this.showModal = true;
          }
        }
      }
    },
    onDeleteFile(fileData) {
      let index = this.siteQualityReviewItems.findIndex(
        f => f.id === fileData.index
      );
      this.siteQualityReviewItems.splice(index, 1);
    },
    onDragCallBack(evt) {
      return (
        evt.draggedContext.element.url != null &&
        evt.relatedContext.element.url != null
      );
    },
    getExtensionFromUrl(url) {
      if (url) {
        var splited = url.split(".");
        return splited.length > 1 ? splited[splited.length - 1] : null;
      }
      return null;
    },
    // async submit() {
    //   this.$v.$touch();
    //   if (this.$v.$invalid) {
    //     return;
    //   }
    // },
    capitalizeFirstLetter(string) {
      return stringFormatter.capitalizeFirstLetter(string);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${month}/${day}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    }
  },
  computed: {
    accept() {
      return "image/png,image/gif,image/jpeg,image/webp";
    },
    extensions() {
      return "gif,jpg,jpeg,png,webp";
    }
  }
};
</script>
